
import { format, parseISO } from "date-fns";

export const DateFormate = (date, formatOfDate) => {
    try {
        if (!formatOfDate) formatOfDate = "MM/dd/yyyy";
        const dateParsed = parseISO(date);
        const formattedDate = format(dateParsed, formatOfDate);
        return formattedDate;
    } catch {
        return "";
    }
};

let debounceTimer;
export function debounce(callback, delay) {
    if (delay === undefined) delay = 500;

    clearTimeout(debounceTimer);

    debounceTimer = setTimeout(() => {
        callback();
    }, delay);
}

export const formatNumber = (num) => {
    return num.toLocaleString();
};

export const getBadge = (contentType, isPrimary) => {
    switch (contentType) {
        case 'analyst_reports':
            return (
                <span className={`directions-badge analyst-report${isPrimary ? ' primary' : ''}`}>
                    <span className="directions-badge-icon">&nbsp;</span>
                    <span className="directions-badge-text">Analyst Report</span>
                </span>);

        case 'update_issues':
            return (
                <span className={`directions-badge analyst-report${isPrimary ? ' primary' : ''}`}>
                    <span className="directions-badge-icon">&nbsp;</span>
                    <span className="directions-badge-text">Update Issues</span>
                </span>);

        case 'charts_illustrations':
            return (
                <span className={`directions-badge analyst-report${isPrimary ? ' primary' : ''}`}>
                    <span className="directions-badge-icon">&nbsp;</span>
                    <span className="directions-badge-text">Charts &amp; Illustrations</span>
                </span>);

        case 'in_brief':
            return (
                <span className={`directions-badge analyst-report${isPrimary ? ' primary' : ''}`}>
                    <span className="directions-badge-icon">&nbsp;</span>
                    <span className="directions-badge-text">In Brief</span>
                </span>);

        case 'deep_dives':
            return (
                <span className={`directions-badge analyst-report${isPrimary ? ' primary' : ''}`}>
                    <span className="directions-badge-icon">&nbsp;</span>
                    <span className="directions-badge-text">Deep Dive</span>
                </span>);

        case 'sidebar':
            return (
                <span className={`directions-badge analyst-report${isPrimary ? ' primary' : ''}`}>
                    <span className="directions-badge-icon">&nbsp;</span>
                    <span className="directions-badge-text">Sidebar</span>
                </span>);

        case 'webinars':
            return (
                <span className={`directions-badge webinar${isPrimary ? ' primary' : ''}`}>
                    <span className="directions-badge-icon">&nbsp;</span>
                    <span className="directions-badge-text">Webinar</span>
                </span>);

        case 'post':
            return (
                <span className={`directions-badge blog${isPrimary ? ' primary' : ''}`}>
                    <span className="directions-badge-icon">&nbsp;</span>
                    <span className="directions-badge-text">Blog</span>
                </span>);

        case 'roadmaps':
            return (
                <span className={`directions-badge roadmap${isPrimary ? ' primary' : ''}`}>
                    <span className="directions-badge-icon">&nbsp;</span>
                    <span className="directions-badge-text">Roadmap</span>
                </span>);

        case 'content_groups':
            return (
                <span className={`directions-badge roadmap${isPrimary ? ' primary' : ''}`}>
                    <span className="directions-badge-icon">&nbsp;</span>
                    <span className="directions-badge-text">Roadmap</span>
                </span>);

        case 'infographics':
            return (
                <span className={`directions-badge infographic${isPrimary ? ' primary' : ''}`}>
                    <span className="directions-badge-icon">&nbsp;</span>
                    <span className="directions-badge-text">Infographic</span>
                </span>);

        case 'podcasts':
            return (
                <span className={`directions-badge podcast${isPrimary ? ' primary' : ''}`}>
                    <span className="directions-badge-icon">&nbsp;</span>
                    <span className="directions-badge-text">Podcast</span>
                </span>);

        case 'videos':
            return (
                <span className={`directions-badge webinar${isPrimary ? ' primary' : ''}`}>
                    <span className="directions-badge-text">Video</span>
                </span>);

        case 'kits_collections':
            return (
                <span className={`directions-badge kits-collections${isPrimary ? ' primary' : ''}`}>
                    <span className="directions-badge-icon">&nbsp;</span>
                    <span className="directions-badge-text">Kits &amp; Collections</span>
                </span>);

        case 'kits_coll':
            return (
                <span className={`directions-badge kits-collections${isPrimary ? ' primary' : ''}`}>
                    <span className="directions-badge-icon">&nbsp;</span>
                    <span className="directions-badge-text">Kits &amp; Collections</span>
                </span>);

        case 'getting_started':
            return (
                <span className={`directions-badge kits-collections${isPrimary ? ' primary' : ''}`}>
                    <span className="directions-badge-icon">&nbsp;</span>
                    <span className="directions-badge-text">Kits &amp; Collections</span>
                </span>);

        case 'glossary_entry':
            return (
                <span className={`directions-badge licensing-reference${isPrimary ? ' primary' : ''}`}>
                    <span className="directions-badge-icon">&nbsp;</span>
                    <span className="directions-badge-text">Reference</span>
                </span>);

        case 'licensing_glossary_entry':
            return (
                <span className={`directions-badge licensing-reference${isPrimary ? ' primary' : ''}`}>
                    <span className="directions-badge-icon">&nbsp;</span>
                    <span className="directions-badge-text">Licensing Reference</span>
                </span>);

        case 'product_glossary_entry':
            return (
                <span className={`directions-badge licensing-reference${isPrimary ? ' primary' : ''}`}>
                    <span className="directions-badge-icon">&nbsp;</span>
                    <span className="directions-badge-text">Product Reference</span>
                </span>);

        case 'product_family':
            return (
                <span className={`directions-badge`}>
                    <span className="directions-badge-text">Product Family</span>
                </span>);

        case 'product':
            return (
                <span className={`directions-badge`}>
                    <span className="directions-badge-text">Product</span>
                </span>);

        case 'authors_analysts':
            return (
                <span className={`directions-badge`}>
                    <span className="directions-badge-text">Authors &amp; Analysts</span>
                </span>);

        case 'summary_subject_area':
            return (
                <span className={`directions-badge`}>
                    <span className="directions-badge-text">Subject Area</span>
                </span>);

        case 'subject_area':
            return (
                <span className={`directions-badge`}>
                    <span className="directions-badge-text">Subject Area</span>
                </span>);

        case 'internal_page':
            return (
                <span className={`directions-badge`}>
                    <span className="directions-badge-text">Page</span>
                </span>);

        case 'page':
            return (
                <span className={`directions-badge`}>
                    <span className="directions-badge-text">Page</span>
                </span>);

        case 'events':
            return (
                <span className={`directions-badge`}>
                    <span className="directions-badge-text">Event</span>
                </span>);

        default:
            return (
                <span>Content Type: {contentType}</span>);
    }
}

export const formatPrice = (value) => {
    const num = Number(value || 0);
    return num.toLocaleString("en-US", {
        style: "currency",
        currency: "USD",
    });
};

// Format plan description with dynamic pricing
export const formatPlanDescription = (event_price, plans, plan) => {
    if (!plan) return '';
    const priceFormatted = formatPrice(plan.price);
    const savingsInDollars = calculateSavings(event_price, plans, plan);
    const savingsFormatted = savingsInDollars > 0 ? ` (${formatPrice(savingsInDollars)} in savings)` : '';
    return `${plan.plan_label} - ${priceFormatted}/yr${savingsFormatted}`;
};

// Calculate savings for a plan (returns value in dollars)
const calculateSavings = (event_price, plans, plan) => {
    if (!plan || !plans || plans.length === 0) return 0;
    // Get individual membership price (Single Plan price)
    const singlePlan = plans.find(p => p.plan_id === 1);
    if (!singlePlan) return 0;

    const individualMembershipPrice = singlePlan.price; // in dollars
    const individualTicketPrice = event_price?.price || 0; // in dollars

    // Calculate total if purchased individually (all in dollars)
    const individualTotal = (plan.atlas_users * individualMembershipPrice) + (plan.training_tickets * individualTicketPrice);

    // Savings = individual total - plan price (all in dollars)
    const savings = individualTotal - plan.price;
    return savings > 0 ? savings : 0;
};

// LBC training-ticket bulk discount.
// A single ticket is charged at full price. As soon as two or more tickets are
// purchased, every ticket (including the first) gets the 10% bulk discount.
// This mirrors the backend pricing in includes/ecommerce/rest.php.
export const getFirstTicketPrice = (cart, im_custom) => {
    const totalAttendees = cart?.attendees?.length || 0;
    const eventPrice = im_custom?.event_price || {};
    const fullPrice = Number(eventPrice.price || 0);
    const discountPrice = Number(eventPrice.extra_training_tickets_price || 0);
    return totalAttendees >= 2 ? discountPrice : fullPrice;
};

// Subtotal for LBC training tickets, applying the bulk discount rule above.
// For plans that already include training tickets, only the extra attendees
// (isDefault === "0") are charged — the included tickets are free.
export const calculateTrainingSubtotal = (cart, im_custom) => {
    const attendees = cart?.attendees || [];
    if (attendees.length === 0) return 0;

    const extraAttendeesPrice = attendees
        .filter((a) => a.isDefault === "0")
        .reduce((sum, a) => sum + Number(a.price || 0), 0);

    if (cart?.activePlan?.training_tickets > 0) {
        return extraAttendeesPrice;
    }

    return getFirstTicketPrice(cart, im_custom) + extraAttendeesPrice;
};

// Per-row price for an attendee in the cart's attendee list.
// Mirrors the bulk-discount rule: once 2+ tickets are in the cart, the first
// (paid) seat is also discounted. Plan-included seats are seeded at price 0 and
// stay free ("Included in Plan"), so the `price > 0` guard leaves them alone.
export const getAttendeeRowPrice = (index, person, totalAttendees, extraPersonPrice) => {
    const price = Number(person?.price || 0);
    if (index === 0 && totalAttendees >= 2 && price > 0) {
        return Number(extraPersonPrice || price);
    }
    return price;
};

export const generateID = (prefix = "id_") => {
    return prefix + Math.random().toString(36).substr(2, 9);
}

export const isValidateEmail = (value) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!regex.test(value)) {
        return false;
    } else {
        return true;
    }
};

export const PaymentDateFormat = ({ input }) => {
    const formattedDate = new Date(input.replace(" ", "T") + "Z").toLocaleString("en-US", {
        month: "2-digit",
        day: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: true
    });

    return <span>Payment Date: {formattedDate}</span>;
}
